import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as TryAgain } from 'assets/svg/icon-try-again.svg'

function IconTryAgain(props: IconProps): JSX.Element {
  const title = 'icon-try-again'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <TryAgain {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconTryAgain
